<script>
import devolucionesIndex from './Componentes/quicktable.vue'
export default {
    name: 'EntradasYDevoluciones',
    components: {
        devolucionesIndex
    }
}
</script>

<template>
    <div id="Devoluciones">
        <devoluciones-index />
    </div>
</template>